import React from 'react';

// import { StyledTableRow, StyledTableCell, HeaderTableCell, SkeletonContainer } from './styles';
import { TableHead, TableBody, Table } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import styled from 'styled-components';
// import useTableState from './useTableState';
import { StyledBox, StyledTableCell, StyledTableRow, StyledTypography } from 'styles/common';

import { getColorFromKey } from 'constants/helper';
import { PlusIcon2 } from 'constants/icons';

import FunctionAndGradeEditableRow, {
  getLeftPadding,
  getLeftPosition,
  horizontalLineWidth,
  StyledHorizontalLine,
  StyledVerticalLine,
} from './FunctionAndGradeEditableRow';

const getVerticalLines = (nestingLevel, levelsForWhichLinesToBeDrawn) => {
  if (nestingLevel === 0) return null;

  return (
    <>
      {levelsForWhichLinesToBeDrawn.map((num) => (
        <StyledVerticalLine left={`-${getLeftPosition(nestingLevel + 1 - num)}`} />
      ))}
      <StyledVerticalLine left={`-${horizontalLineWidth}px`} bottom="50%" />
      <StyledHorizontalLine width={`${horizontalLineWidth}px`} />
    </>
  );
};

const CircularIcon = styled(Avatar)`
  width: 24px;
  height: 24px;

  background-color: transparent;
  color: ${(props) => getColorFromKey(props.color)};

  border: ${(props) => `1px solid ${getColorFromKey(props.color)}`};
`;

const StyledPlusIcon = styled(PlusIcon2)`
  height: 10px;
  width: 10px;

  fill: ${(props) => props.theme.palette.primary.main};
`;

const ExpandedFunctionInCard = ({
  tableTag,
  enableParentExpansion,
  disableParentExpansion,
  nestingLevel = 1,
  showExpandedCard,
  modalView,
  enableCreation,
  selectTag,
  levelsForWhichLinesToBeDrawn,
  editingTags,
  setEditingTags,
  timePeriodsList = [],
  selectedTimeBoundPeriod,
  searchString = '',
  func,
  isEnterpriseAccessOnly,
  parentArrayOfFunction = [],
  jobFunctionId,
  jobGradeUI,
  jobRoleId,
  onSelect,
}) => (
  //   const {
  //     tags,
  //     loading,
  //     newTag,
  //     showTagCreationRow,
  //     getAllTags,
  //     updateTag,
  //     createNewTag,
  //     enableTagEditing,
  //     disableEditingForAllTags,
  //     handleToggleActive,
  //     displayNewTagCreationRow,
  //     hideNewTagCreationRow,
  //     toggleTagEditing,
  //     disableExpansion,
  //     enableExpansion
  //   } = useTableState({
  //     tableTag,
  //     enableParentExpansion,
  //     setEditingTags
  //   });

  //   useEffect(() => {
  //     if (showExpandedCard) getAllTags();
  //   }, [showExpandedCard]);

  <StyledTableRow>
    <StyledTableCell border-bottom="none" padding="none" colSpan={5}>
      <>
        <Table>
          <TableHeader modalView={modalView} />
          <TableBody>
            {/* <FunctionAndGradeEditableRow
                key={`${func.name}-function-row`}
                func={func}
                //   readonly={isEnterpriseAccessOnly && !isEnterpriseUser}
                isExpandable={func?.jobGradeList?.length}
                isEditing={func.isEditing}
                //   disableExpansion={() => disableExpansion(func.uuid)}
                //   enableExpansion={() => enableExpansion(func.uuid)}
                hasChildTags={func.hasChildTags}
                canHaveChildTags={true}
                //   allowDescriptionNewline={allowDescriptionNewline}
                //   loadingFunctions={loadingFunctions}
                //   gradesForOrg={gradesForOrg}
                //   refetchData={fetchData}
              /> */}

            {showExpandedCard &&
              func.childFunctions &&
              func.childFunctions?.map((childFunc, index) => (
                <FunctionAndGradeEditableRow
                  key={`${childFunc.name}-function-row`}
                  func={childFunc}
                  // readonly={isEnterpriseAccessOnly && !isEnterpriseUser}
                  isExpandable={childFunc?.jobGradeList?.length}
                  isEditing={childFunc.isEditing}
                  // disableExpansion={() => disableExpansion(func.uuid)}
                  // enableExpansion={() => enableExpansion(func.uuid)}
                  hasChildTags={childFunc.hasChildTags}
                  canHaveChildTags
                  // allowDescriptionNewline={allowDescriptionNewline}
                  // loadingFunctions={loadingFunctions}
                  // gradesForOrg={gradesForOrg}
                  // refetchData={fetchData}
                  nestingLevel={nestingLevel}
                  idx={index}
                  levelsForWhichLinesToBeDrawn={levelsForWhichLinesToBeDrawn}
                  parentArrayOfFunction={parentArrayOfFunction}
                  jobFunctionId={jobFunctionId}
                  jobGradeUI={jobGradeUI}
                  jobRoleId={jobRoleId}
                  modalView={modalView}
                  onSelect={onSelect}
                />
              ))}
          </TableBody>
        </Table>
      </>
    </StyledTableCell>
  </StyledTableRow>
);
const TableHeader = ({ modalView = false }) => (
  <TableHead>
    {/* <HeaderTableCell padding="0" width="40%" />
      <HeaderTableCell padding="0" width="25%" /> */}
    {/* {!modalView && <HeaderTableCell padding="0" width="25%" />} */}
    {/* <HeaderTableCell padding="0" width="10%" /> */}
  </TableHead>
);

const CreateSubObjectiveRow = ({ nestingLevel, levelsForWhichLinesToBeDrawn, displayNewTagCreationRow }) => (
  <StyledTableRow>
    <StyledTableCell paddingtop="0" paddingBottom="0" paddingLeft={getLeftPadding(nestingLevel)} colSpan={4} border>
      <StyledCellContainer>
        {getVerticalLines(nestingLevel, levelsForWhichLinesToBeDrawn)}
        <StyledBox
          display="inline-flex"
          alignItems="center"
          onClick={displayNewTagCreationRow}
          style={{ cursor: 'pointer' }}
        >
          <CircularIcon color="primary">
            <StyledPlusIcon />
          </CircularIcon>
          <StyledTypography2 color="primary" leftGutter={3}>
            Create New Sub Objective
          </StyledTypography2>
        </StyledBox>
      </StyledCellContainer>
    </StyledTableCell>
  </StyledTableRow>
);

const StyledCellContainer = styled.div`
  height: 62px;
  position: relative;
  display: flex;
  align-items: center;
`;

const StyledTypography2 = styled(StyledTypography)`
  line-height: 3;
  font-size: 0.875rem;
`;

export default ExpandedFunctionInCard;
